import { Injectable } from '@angular/core';
import { UserProfileService } from '../api/user-profile.service';

// Translations
import * as en_translations from '../../i18n/locale/en-US.json';
import * as ja_translations from '../../i18n/locale/ja.json';
import * as zh_translations from '../../i18n/locale/zh.json';
import * as twn_translations from '../../i18n/locale/zh-Hant.json';
import { find } from 'lodash';
import { DataObject } from '../models/data-objects.models';

@Injectable({
  providedIn: 'root'
})
export class TranslateService {
  private _translations: any;
  private _currentLang = 'en-US'; // English is the default language

  constructor(private userProfile: UserProfileService) { }

  private setTranslationsFile() {
    this._currentLang = this.userProfile.getLocale();
    switch (this._currentLang) {
      case 'zh':
        this._translations = (zh_translations as any).default;
        break;
      case 'ja':
        this._translations = (ja_translations as any).default;
        break;
      case 'zh-Hant':
        this._translations = (twn_translations as any).default;
        break;
      default:
        this._translations = (en_translations as any).default;
        break;
    }
  }

  getTranslation(key: string): string {
    this.setTranslationsFile();
    // in future someone adds keys in en.json or ja.json etc files , we better convert to lower case from the key as well the json entry.
    // for china dealfile checklist, we are using the same keys. thats the reason we have added country as china to all the json;s
    // this to differentaite between china vs other question question because of the same keys.
    let translatedKey;
    if (['zh', 'ja', 'zh-Hant'].includes(this._currentLang)) {
      const keys = this._translations.filter(function (o: DataObject) {
        return o.key.trim().toLowerCase() === key.trim().toLowerCase();
      });
      if (keys && keys.length > 1) {
        for (let count = 0; count < keys.length; count++) {
          if (keys[count]['country'] && keys[count]['country'] === 'china') {
            translatedKey = keys[count];
            if (translatedKey && translatedKey.value) {
              return translatedKey.value;
            }
          } else {
            translatedKey = keys[0];
            if (translatedKey && translatedKey.value) {
              return translatedKey.value;
            }
          }
        }
      } else {
        translatedKey = keys[0];
        if (translatedKey && translatedKey.value) {
          return translatedKey.value;
        }
      }
    } else {
      translatedKey = find(this._translations, function (o: DataObject) {
        return o.key.trim().toLowerCase() === key.trim().toLowerCase();
      });
      if (translatedKey && translatedKey.value) {
        return translatedKey.value;
      }
    }
    return '';
  }

}
